import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig, HaftpflichtAdditional } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY = 'HAFTPFLICHT-SACHSCHADEN-HANDY';

export interface HaftpflichtSachschadenHandyAdditional extends HaftpflichtAdditional {
  haushalt?: boolean;
}

export interface HaftpflichtSachschadenHandyModelConfig extends BaseHaftpflichtSchadenModelConfig {
  additional: HaftpflichtSachschadenHandyAdditional;
}

export class HaftpflichtSachschadenHandyModel extends BaseHaftpflichtSchadenModel {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY;
  @serializable() additional: HaftpflichtSachschadenHandyAdditional;

  constructor(config: HaftpflichtSachschadenHandyModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set from super()
  }
}
